import {
  Box,
  Stack,
  TextField,
  Button,
  Chip,
  IconButton,
  Collapse,
  Divider,
  Typography,
  Autocomplete,
  styled,
} from '@mui/material'
import { useState } from 'react'
import {
  SelectInputBasic,
  SelectInputObject,
} from '../../../../../components/inputs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExpand, faMagnifyingGlass, faMapLocation, faMapMarkerAlt, faTimes } from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import lightTheme from '../../../../../styles/theme/lightTheme'



const CustomAutocomplete = styled(Autocomplete)(({ theme }) => ({
  width: '100%',
  height: '100%',
  borderWidth: 0,
  borderRadius: 0,
  overflow: 'hidden',
  fontFamily: 'Century Gothic',
  fontSize: 12,
  lineHeight: '140%',
  color: lightTheme.palette.grey.grey,

  '& .MuiOutlinedInput-root': {
    height: '100%',
    borderRadius: 0,
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },

  '& .MuiInputBase-input': {
    padding: '0 14px',
    textAlign: 'center',
  },

  '& .MuiAutocomplete-paper': {
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    marginTop: '8px',
    maxHeight: '240px',
    overflow: 'auto',
    border: '1px solid #e0ecef',
  },

  '& .MuiAutocomplete-option': {
    padding: '12px 16px',
    fontSize: 14,
    fontFamily: 'Century Gothic',
    minHeight: '48px',
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #f0f0f0',
    '&:hover': {
      backgroundColor: '#f8f9fa',
    },
    '&[aria-selected="true"]': {
      backgroundColor: '#667eea',
      color: '#FFFFFF',
    },
  },

  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },

  [theme.breakpoints.up('lg')]: {
    fontSize: 14,
  },
}))

export default function JobFilterPanel({
  handleClearSearch,
  search,
  handleJobTitleChange,
  handleJobChange,
  jobTitleSuggestions,
  loadingJobs,

  filterSelect,
  handleFilterSelect,
  contractTypeOptions,

  orderSelect,
  handleOrderSelect,
  order,

  location,
  handleLocationChange,

  status,
  handleStatusChange,

  startDate,
  endDate,
  handleDateRangeChange,

  handleClearFilters,
  clearFilterSelect,

  filteredOptions,
  city,
  handleCityChange,
  handleCityInputChange,
  loading,
  citySuggestions,
  stateSuggestions,
  cityInput,
  open,
  setOpen,
}) {
  const { t, i18n } = useTranslation()
  const [openAdvanced, setOpenAdvanced] = useState(false)

  return (
    <Box
      sx={{
        /* position: 'sticky', */
        top: { xs: 100, sm: 100, md: 100, lg: 150 },
        zIndex: 20,
        backgroundColor: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 2,
        p: 2,
        mb: 2,
      }}
    >
      {/* ================= TOP BAR ================= */}
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
        {/* SEARCH (MAIN) */}
        <Box sx={{ flex: 3 }}>
          <CustomAutocomplete
            freeSolo
            options={jobTitleSuggestions}
            value={search}
            onChange={handleJobChange}
            onInputChange={handleJobTitleChange}
            loading={loadingJobs}
            noOptionsText={
              loadingJobs
                ? t('home.loading')
                : jobTitleSuggestions.length === 0 && search.length > 2
                  ? t('home.noJobsFound')
                  : ''
            }
            placeholder={t('home.jobTitlePlaceholder')}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder={
                  t('filter.searchText') + '...'
                }
                InputProps={{
                  ...params.InputProps,
                  style: {
                    padding: '0 14px',
                    textAlign: 'center',
                    height: '100%',
                  },
                  endAdornment: (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                      }}
                    >
                      {loadingJobs && (
                        <div
                          style={{
                            padding: '0 4px',
                            display: 'flex',
                            alignItems: 'center',
                            position: 'absolute',
                            right: 30,
                            color: '#666',
                          }}
                        >
                          <div
                            style={{
                              width: '16px',
                              height: '16px',
                              border: '2px solid #666',
                              borderTop: 'none',
                              borderLeft: 'none',
                              animation: 'spin 1s linear infinite',
                              borderRadius: '50%',
                              borderRight: '2px solid transparent',
                              borderColor: '#666 transparent',
                              borderStyle: 'solid',
                            }}
                          ></div>
                        </div>
                      )}
                      {/* {(city || cityInput) && !loading && (
                                  <IconButton
                                    onClick={handleClearCity}
                                    size="small"
                                    style={{ 
                                      padding: '4px',
                                      marginRight: '4px',
                                      color: '#666',
                                      '&:hover': {
                                        color: '#333',
                                        backgroundColor: '#f5f5f5'
                                      }
                                    }}
                                  >
                                    <FontAwesomeIcon 
                                      icon={faTimes} 
                                      style={{ 
                                        fontSize: '12px',
                                        cursor: 'pointer'
                                      }} 
                                    />
                                  </IconButton>
                                )} */}
                      {params.InputProps.endAdornment}
                    </div>
                  ),
                }}

                sx={{
                  width: '100%',
                  height: 45,
                  '& .MuiOutlinedInput-root': {
                    height: '100%',
                    borderRadius: '5px',
                    border: `1px solid ${lightTheme.palette.grey.main}`,
                    backgroundColor: '#FFFFFF',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '0',
                    '& fieldset': {
                      border: 'none',
                    },
                    '&:hover fieldset': {
                      border: 'none',
                    },
                    '&.Mui-focused fieldset': {
                      border: 'none',
                    },
                  },
                  '& .MuiInputBase-input': {
                    flex: 1,
                    color: lightTheme.palette.text.primary,
                    fontFamily: 'Century Gothic',
                    fontSize: 14,
                    lineHeight: '140%',
                    letterSpacing: '0.2px',
                    padding: '0',
                  },
                }}
              />
            )}
          />
        </Box>
        <Box sx={{ flex: 3 }}>
          <CustomAutocomplete
            freeSolo
            options={filteredOptions}
            value={city || ''}
            onChange={handleCityChange}
            onInputChange={handleCityInputChange}
            loading={loading}
            noOptionsText={
              loading
                ? t('home.loading')
                : citySuggestions.length === 0 &&
                  stateSuggestions.length === 0 &&
                  cityInput.length > 2
                  ? t('home.noCitiesFound')
                  : ''
            }
            placeholder={t('home.cityPlaceholder')}
            filterOptions={(x) => x}
            getOptionLabel={(option) => option?.name || ''}


            open={open && filteredOptions.length > 0}
            onOpen={() => {
              if (filteredOptions.length > 0) setOpen(true);
            }}
            onClose={() => setOpen(false)}
            disableOpenOnFocus

            /* renderOption={(props, option) => (
              <Box sx={{ display: 'flex', alignItems: 'center', py: 1 }}>
                <FontAwesomeIcon 
                  icon={faMapMarkerAlt} 
                  style={{ color: '#667eea', marginRight: '8px', marginLeft: '25px', fontSize: '14px' }} 
                />
                <Typography variant="body2" sx={{ ml: 1, flexGrow: 1 }}>{option}</Typography>
              </Box>
            )} */
            renderOption={(props, option) => (
              <Box
                {...props}
                sx={{ display: 'flex', alignItems: 'center', py: 1 }}
              >
                <FontAwesomeIcon
                  icon={option.type === 'city' ? faMapMarkerAlt : faMapLocation}
                  style={{
                    color: '#667eea',
                    marginRight: '8px',
                    marginLeft: '0px',
                    fontSize: '14px',
                  }}
                />
                <Typography variant="body2" sx={{ ml: 1, flexGrow: 1, textTransform: 'capitalize' }}>
                  {option.name}
                </Typography>
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder={
                  t('home.cityPlaceholder') + (cityInput ? ' ' + cityInput : '')
                }
                InputProps={{
                  ...params.InputProps,
                  style: {
                    padding: '0 14px',
                    textAlign: 'center',
                    height: '100%',
                  },
                  endAdornment: (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                      }}
                    >
                      {loading && (
                        <div
                          style={{
                            padding: '0 4px',
                            display: 'flex',
                            alignItems: 'center',
                            position: 'absolute',
                            right: 30,
                            color: '#666',
                          }}
                        >
                          <div
                            style={{
                              width: '16px',
                              height: '16px',
                              border: '2px solid #666',
                              borderTop: 'none',
                              borderLeft: 'none',
                              animation: 'spin 1s linear infinite',
                              borderRadius: '50%',
                              borderRight: '2px solid transparent',
                              borderColor: '#666 transparent',
                              borderStyle: 'solid',
                            }}
                          ></div>
                        </div>
                      )}
                      {/* {(city || cityInput) && !loading && (
                                  <IconButton
                                    onClick={handleClearCity}
                                    size="small"
                                    style={{ 
                                      padding: '4px',
                                      marginRight: '4px',
                                      color: '#666',
                                      '&:hover': {
                                        color: '#333',
                                        backgroundColor: '#f5f5f5'
                                      }
                                    }}
                                  >
                                    <FontAwesomeIcon 
                                      icon={faTimes} 
                                      style={{ 
                                        fontSize: '12px',
                                        cursor: 'pointer'
                                      }} 
                                    />
                                  </IconButton>
                                )} */}
                      {params.InputProps.endAdornment}
                    </div>
                  ),
                }}

                sx={{
                  width: '100%',
                  height: 45,
                  '& .MuiOutlinedInput-root': {
                    height: '100%',
                    borderRadius: '5px',
                    border: `1px solid ${lightTheme.palette.grey.main}`,
                    backgroundColor: '#FFFFFF',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '0',
                    '& fieldset': {
                      border: 'none',
                    },
                    '&:hover fieldset': {
                      border: 'none',
                    },
                    '&.Mui-focused fieldset': {
                      border: 'none',
                    },
                  },
                  '& .MuiInputBase-input': {
                    flex: 1,
                    color: lightTheme.palette.text.primary,
                    fontFamily: 'Century Gothic',
                    fontSize: 14,
                    lineHeight: '140%',
                    letterSpacing: '0.2px',
                    padding: '0',
                  },
                }}
              />
            )}
          />
        </Box>



        {/* ADVANCED TOGGLE */}
        <Button
          variant="outlined"
          onClick={() => setOpenAdvanced((p) => !p)}
          endIcon={
            openAdvanced ? (
              <FontAwesomeIcon icon={faExpand} />
            ) : (
              <FontAwesomeIcon icon={faExpand} />
            )
          }
          sx={{
            whiteSpace: 'nowrap',
          }}
        >
          
          {t('filter.filters')}
        </Button>

        {/* CLEAR */}
        <Button
          variant="contained"
          onClick={handleClearFilters}
        >
          {t('filter.reset')}
        </Button>
      </Stack>

      {/* ================= ADVANCED FILTERS ================= */}
      <Collapse in={openAdvanced}>
        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          
          {t('filter.advancedFilters')}
        </Typography>

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          flexWrap="wrap"
        >


          {/* TYPE FILTER */}
          <Box sx={{ flex: 1 }}>
            <SelectInputBasic
              type="border"
              items={contractTypeOptions}
              value={filterSelect.id}
              handleChange={handleFilterSelect}
            />
          </Box>

          {/* SORT */}
          <Box sx={{ flex: 1 }}>
            <SelectInputObject
              type="border"
              items={order}
              value={orderSelect}
              handleChange={handleOrderSelect}
            />
          </Box>

          {/* Status */}
          {/* <Box sx={{ flex: 1, minWidth: 200 }}>
            <SelectInputBasic
              type="border"
              items={status?.options}
              value={status}
              handleChange={handleStatusChange}
            />
          </Box> */}

          {/* Date Range */}
          {/* <Box sx={{ flex: 2, minWidth: 280 }}>
              <DateRangePicker
                startDate={startDate}
                endDate={endDate}
                onChange={handleDateRangeChange}
              />
            </Box> */}
        </Stack>
      </Collapse>

      {/* ================= ACTIVE FILTERS ================= */}
      <Divider sx={{ my: 2 }} />

      <Stack direction="row" flexWrap="wrap" columnGap={1} rowGap={1.5}>
        {search && (
          <Chip
            label={`${t('home.search')}: ${search}`}
            onDelete={() => handleJobChange('')}
          />
        )}

        {filterSelect?.id !== 0 && (
          <Chip
            label={`${t('filter.contractType')}: ${filterSelect.id}`}
            onDelete={() => clearFilterSelect(null)}
          />
        )}

        {city.name && city.name !== '' && (
          <Chip
            label={city.type === 'city' ? `${t('home.city')}: ${city.name}` : `${t('home.canton', 'Canton')}: ${city.name}`}
            onDelete={() => handleCityChange(null)}
          />
        )}

        {location && (
          <Chip
            label={`Location: ${location}`}
            onDelete={() => handleLocationChange(null)}
          />
        )}
      </Stack>
    </Box>
  )
}
